import React from 'react';
import { Provider } from 'mobx-react';
import allStores from 'stores/all';


/** boilerplate setup for all pages, until we bring it together in a SPA with react-router */
export const App: React.FC = (props) => {
    return (
        <Provider {...allStores}>
            {props.children}
        </Provider>
    )
}